import { ReactElement } from 'react';
import { LegendContent } from './styles';
import { Circle } from '../GraphTooltip/styles';

interface LegendProps {
  label: string;
  color: string;
}

export function Legend({
  color,
  label,
}: Readonly<LegendProps>): ReactElement {
  return (
    <LegendContent>
      <Circle color={color} />
      <span>{label}</span>
    </LegendContent>
  );
}
